export type ClubContact = {
  label: string;
  text: string;
  href?: string;
};

export type ClubInfo = {
  name: string;
  address: string;
  hours: string;
  contacts: ClubContact[];
};

export const CLUB_INFO: ClubInfo = {
  name: 'Тропа',
  address: 'г. Минск, ул. Маяковского, 176, 4 этаж, 403 каб.',
  hours: 'Уточняется',
  contacts: [],
};

export const CLUB_MAP_URL = 'https://yandex.by/maps/-/CLxNqD-t';
